import React from 'react';
import { Box } from '@chakra-ui/react';

export function PageLoading() {
  return (
    <Box
      display='flex'
      flexDirection='column'
      gap='4'
      h='100vh'
      p='4'
      bg='oci.surface'
      css={{
        '& > div': {
          bg: 'var(--oci-colors-oci-base-100)',
          animation: 'oci-reveal 0.8s ease 0s infinite alternate'
        },
        '& > div:nth-child(1)': { height: '10%' },
        '& > div:nth-child(2)': { height: '25%' },
        '& > div:nth-child(3)': { flexGrow: 1 }
      }}
    >
      <div />
      <div />
      <div />
      <Box
        as='p'
        border={0}
        clip='rect(0, 0, 0, 0)'
        h='1px'
        m='-1px'
        overflow='hidden'
        p={0}
        position='absolute'
        w='1px'
      >
        Loading page...
      </Box>
    </Box>
  );
}
